import { ArrowRight, ArrowRight2, Eye, More } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { LSSB } from "../utils/LSSB_live";
import Moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { University } from "../component.js/data";

const Dashboard = () => {
  const [timeOfDay, setTimeOfDay] = useState("");
  const [page, setPage] = useState("1");
  const [isLoading, setIsLoading] = useState(false);
  let userData = sessionStorage.getItem("lssbAdminData");

  userData = JSON.parse(userData);

  useEffect(() => {
    const getCurrentTimeOfDay = () => {
      const currentHour = new Date().getHours();
      if (currentHour >= 5 && currentHour < 12) {
        return "Morning";
      } else if (currentHour >= 12 && currentHour < 18) {
        return "Afternoon";
      } else {
        return "Evening";
      }
    };

    setTimeOfDay(getCurrentTimeOfDay());
  }, []);
  function formatDate(datetimeStr) {
    const date = Moment(datetimeStr);
    const formattedDate = date.format("MMM DD, YYYY");
    return formattedDate;
  }

  const fetchApplications = async (page) => {
    let res = await LSSB.make_API_call({
      _endpoint: "fetch_applications",
      $k: userData.token,
      $page: 1,
      $items_per_page: 10, // or 10 default,
      $join: {
        // @@ aggregate data from another collection (or table in SQL terms)
        collection: "applicants",
        id_key: "_fields.applicant_id", // @@ id_key on this data to aggregate on the $join collection, applicant_id in this case
      },

      $where: { "_fields.applicant_id": userData.user?._id },
      // $items_per_page: 10 -- default is 10
    });
    return res;
    // //console.log("grants rsss=====>>>", res);
  };
  const ApplicationQuery = useQuery(["g", page], () => fetchApplications(page));
  const Applications = ApplicationQuery?.data?.data?.data || [];
  const pendingfiltered = Applications?.filter(
    (result) => result?.Application_Status === "pending"
  );
  const pendingLength = pendingfiltered?.length;


  const navigate = useNavigate();

  return (
    <div className="p-[16px] md:px-[24px] xl:p-[32px]">
      <div className="mb-[20px] md:mb-[28px] xl:mb-[32px]">
        <h3 className="text-[18px] md:text-[24px] font-meddium text-[#25324B]">
          Good {timeOfDay}, {userData?.user?._fields?.fullname}
        </h3>
        <p className="text-[14px] md:text-[16px] font-meddium text-[#7C8493]">
          {" "}
          These are your applications
        </p>
      </div>
      <ul className="grid grif-cols-1 space-y-5 md:space-y-0 md:grid-cols-3 px-4 md:px-[32px]">
        <li className="p-[16px] min-h-[110px]  rounded-lg md:rounded-none md:p-[20px] xl:p-[24px] flex  items-center gap-2 md:gap-3 xl:gap-4 bg-[#7B61FF]">
          <p className="text-[#fff] font-semibold text-[24px] md:text-[32px] xl:text-[48px] ">
            {Applications.length}
          </p>
          <div className="flex-1">
            {" "}
            <p className="text-[14px] md:text-[18px] font-meddium text-[#fff]">
              {" "}
              Total number of Applications
            </p>
          </div>
          <ArrowRight2 size="24" color="#FFF" />
        </li>
        <li className="p-[16px] min-h-[110px]  rounded-lg md:rounded-none  md:p-[20px] xl:p-[24px] flex items-center gap-2 md:gap-3 xl:gap-4 bg-[#FFB836]">
         

          <p className="text-[#fff] font-semibold text-[24px] md:text-[32px] xl:text-[48px] ">
          {pendingLength ? pendingLength : "0"}
          </p>
          <div className="flex-1">
            {" "}
            <p className="text-[14px] md:text-[18px] font-meddium text-[#fff]">
              {" "}
              Pending Review{" "}
            </p>
          </div>
          <ArrowRight2 size="24" color="#FFF" />
        </li>
        <li className="p-[16px] min-h-[110px] rounded-lg md:rounded-none md:p-[20px] xl:p-[24px] flex  items-center gap-2 md:gap-3 xl:gap-4 bg-[#56CDAD]">
          <p className="text-[#fff] font-semibold text-[24px] md:text-[32px] xl:text-[48px] ">
            0
          </p>
          <div className="flex-1">
            {" "}
            <p className="text-[14px] md:text-[18px] font-meddium text-[#fff]">
              {" "}
              Award Grant{" "}
            </p>
          </div>
          <ArrowRight2 size="24" color="#FFF" />
        </li>
      </ul>

      <div className="rounded-lg overflow-hidden border-[0.8px] border-[#E4E7EC] mt-5 md:mt-9">
        <div className="flex items-center justify-between bg-white p-3">
          <p className=" text-[16px] md:text-lg  text-[#000] leading-[24px] font-medium text-left ">
            Recent Applications
          </p>
          <Link to="/myapplication">
            <button className="flex items-center gap-2">
              {" "}
              <p className=" text-[12px] md:text-base  text-[#AF8544] leading-[20px] font-medium text-left ">
                View More
              </p>
              <ArrowRight size="16" color="#AF8544" />
            </button>
          </Link>
        </div>
        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full mb-6 border-[0.8px] border-r-[0.8px]  border-l-[0.8px] border-[#E4E7EC] rounded-lg">
            <thead className="bg-light-gray">
              <tr className="">
                <th
                  scope="col"
                  className=" px-2 md:px-5 border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex  gap-[6px] md:gap-[12px] items-center my-0">
                    Grant Title
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex whitespace-nowrap gap-[6px] md:gap-[12px] items-center my-0">
                    Education Level
                  </div>
                </th>
             
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex whitespace-nowrap  gap-[6px] md:gap-[12px] items-center my-0">
                    Date Applied
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex gap-[6px] md:gap-[12px] items-center my-0">
                    Status
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex gap-[6px] md:gap-[12px] items-center my-0">
                    Action
                  </div>
                </th>
               
               
              </tr>
            </thead>
            <tbody>
              {isLoading && <div>Loading...</div>}
              {!isLoading && Applications.length === 0 && (
                <tr>
                  <td className="text-center" colSpan="6">
                    <img
                      src="./nodata.gif"
                      className="mx-auto mt-6 h-[70px] "
                      alt=""
                    />
                    <h3 className="text-[30px] leading-[35px]  text-[#1A202C] font-extrabold mb-[6px]">
                      No Application
                    </h3>
                  </td>
                </tr>
              )}
              {Applications &&
                Applications?.map((result, index) => (
                  <tr  onClick={() =>
                    navigate("/application/application-details", {
                      state: result,
                    })
                  } key={index} className="mb-2 hover:bg-light-gray cursor-pointer">
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {result?.Grant}
                    </td>

                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {result?.Edu_Level}
                    </td>
                   
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {formatDate(result?.Date_Applied)}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {" "}
                      <button
                        className={`rounded-[20px] md:rounded-[40px] flex justify-center items-center gap-2 px-[12px]  py-[4px] md:py-[4px] border-[0.5px] ${
                          result?.Application_Status === "Rejected"
                            ? "bg-[#FEECEB] text-[#F44336] border-[#F44336]"
                            : result?.Application_Status === "pending"
                            ? "bg-[#FFF5E6] text-[#F44336] border-[#FF9800]"
                            : "bg-[#EDF7EE] text-[#4CAF50] border-[#4CAF50]"
                        }  text-[10px] md:text-[12px]  font-semibold leading-[16px] md:leading-[18px] `}
                      >
                        <p>{result?.Application_Status}</p>
                      </button>{" "}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      <Eye variant="Linear" color="green" size="20" />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
